// tslint:disable
// this is an auto generated file. This will be overwritten

export const getArtists = `query GetArtists($lang: String) {
  getArtists(lang: $lang) {
    id
    title
    description
    imageURL
    thumbnailURL
    events {
      id
      date
      time
      duration
      venueId
    }
    spotifyURL
    youtubeURL
    type
    ongoing
    menuOrder
  }
}
`;
export const getArts = `query GetArts($lang: String) {
  getArts(lang: $lang) {
    id
    title
    description
    imageURL
    thumbnailURL
    events {
      id
      date
      time
      duration
      venueId
    }
    spotifyURL
    youtubeURL
    type
    ongoing
    menuOrder
  }
}
`;
export const getFamilies = `query GetFamilies($lang: String) {
  getFamilies(lang: $lang) {
    id
    title
    description
    imageURL
    thumbnailURL
    events {
      id
      date
      time
      duration
      venueId
    }
    spotifyURL
    youtubeURL
    type
    ongoing
    menuOrder
  }
}
`;
export const getFavourites = `query GetFavourites {
  getFavourites {
    programId
    type
    excludedEvents
    events
  }
}
`;
export const getFoods = `query GetFoods($lang: String) {
  getFoods(lang: $lang) {
    id
    title
    description
    imageURL
    thumbnailURL
    type
  }
}
`;
export const getStages = `query GetStages($lang: String) {
  getStages(lang: $lang) {
    id
    name
  }
}
`;
export const getInfo = `query GetInfo($lang: String) {
  getInfo(lang: $lang) {
    id
    type
    title
    thumbnailURL
    imageURLs
    contents {
      layout
      text
      items {
        title
        text
      }
    }
    listItemType
    listItemURL
    showInInfoScreen
  }
}
`;
export const getAppData = `query GetAppData($lang: String) {
  getAppData(lang: $lang) {
    artists {
      id
      title
      description
      imageURL
      thumbnailURL
      events {
        id
        date
        time
        duration
        venueId
      }
      spotifyURL
      youtubeURL
      type
      ongoing
      menuOrder
    }
    arts {
      id
      title
      description
      imageURL
      thumbnailURL
      events {
        id
        date
        time
        duration
        venueId
      }
      spotifyURL
      youtubeURL
      type
      ongoing
      menuOrder
    }
    foods {
      id
      title
      description
      imageURL
      thumbnailURL
      events {
        id
        date
        time
        duration
        venueId
      }
      spotifyURL
      youtubeURL
      type
      ongoing
      menuOrder
    }
    families {
      id
      title
      description
      imageURL
      thumbnailURL
      events {
        id
        date
        time
        duration
        venueId
      }
      spotifyURL
      youtubeURL
      type
      ongoing
      menuOrder
    }
    venues {
      id
      name
    }
  }
}
`;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/graphql/queries.ts